<template>
  <div :class="{'user-authenticated': authenticated, 'user-not-authenticated': !authenticated }"
       class="app-layout">
    <div class="container-fluid header-container mb-3">
      <div class="col-lg-6 m-auto border-1">
        <div class="header d-flex flex-column">
          <div class="row">
            <div class="col-6 col-sm-4 col-md-3 col-lg-4 text-left mt-5 mt-sm-3 mt-md-5 mb-2 mb-sm-5 mb-md-5">
              <a class="logo-1" href="/">
                <img alt="Focus ADHD Go" src="/images/adhd.svg">
              </a>
            </div>
            <div
                class="col-12 col-sm-4 col-md-5 col-lg-4 text-left header-center text-white mt-2 mt-sm-5 mt-md-5 mb-5 mb-sm-3 mb-md-5">
              <div class="header-center-top d-none d-sm-inline-block">{{ $t('medtastic.header_text_1') }}</div><br class="d-none d-sm-inline-block">
              <div class="header-center-text mt-1">{{ $t('medtastic.header_text_2') }}</div>
              <div class="header-center-text mt-1">{{ $t('medtastic.header_text_3') }}</div>
            </div>
          </div>
        </div>
        <div class="locale-container">
          <div class="locale-hint">{{ $t('medtastic.page_on') }}</div> <LocaleDropdown :right="true"/>
        </div>
      </div>
    </div>

    <div class="container-fluid content-container mb-3">
      <div id="content" class="col-lg-6 m-auto border-1">
        <o-child/>
      </div>
    </div>

    <event-contact v-if="$route.name === 'medtastic.event_detail'"></event-contact>

    <event-footer
        v-if="$route.name === 'medtastic.event_detail' || $route.name === 'medtastic.event_registration' || $route.name === 'medtastic.event_thanks'"></event-footer>

    <div v-else class="container-fluid footer-container">
      <div class="col-lg-6 m-auto border-1">
        <div class="row">
          <event-footer-text></event-footer-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from '~/components/LocaleDropdown'
import EventContact from '../pages/EventContact'
import EventFooter from '../pages/EventFooter'
import EventFooterText from '../pages/EventFooterText'

export default {
  name: 'app-layout',

  data: () => ({
    sidebarVisible: false
  }),

  components: {
    EventFooterText,
    EventFooter,
    EventContact,
    LocaleDropdown
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/check'
    }),
    year () {
      var d = new Date()
      return d.getFullYear()
    }
  }
}
</script>
